
import React      from 'react';
import CSSModules from 'react-css-modules';

import style from './style.scss';

import Button             from '../Button';
import Label              from '../Label';
import GlobalMessage      from '../GlobalMessage';
import InputGroup         from '../InputGroup';
import TermsAndConditions from '../TermsAndConditions';
import AccordionSection   from '../AccordionSection';

import * as paymentActions from '../../actions/payment';

import costCalculator from '../../services/costCalculator';
import eventFormatter from '../../services/eventFormatter';
import {scrollToElementId} from '../../services/dom/elementScroller';

import { reduxForm } from 'redux-form';
import FancyCheckbox from "../FancyCheckbox";

class BookingConfirmation extends React.Component {

    constructor() {

        super();

        this.state = {
            termsAccepted: false,
            showingTerms: false
        };
    }
    
    componentDidMount() {
        
        this.props.hideGlobalCardError();
        this.props.hideGlobalEventError();
        this.props.hideGlobalDelegatesError();
    }

    _getSector() {

        if (this.props.bookingValues.sector === 'private') {

            return 'Private';

        } else if (this.props.bookingValues.sector === 'public') {

            return 'Public';
        }
    }

    _getCardEnding(cardNumber) {

        const DIGITS_FROM_CARD_END = 4;

        return cardNumber.substr(cardNumber.length - DIGITS_FROM_CARD_END);
    }

    _getPaymentMethod() {

        if (this.props.bookingValues.payment_method === 'card') {

            const cardEnding = this._getCardEnding(this.props.bookingValues.card_details.card_number);

            return (
                <span styleName="review-line">Pay by card, ending in { cardEnding }</span>
            );

        } else if (this.props.bookingValues.payment_method === 'invoice') {

            return (
                <span styleName="review-line">Invoice</span>
            );
        }
    }

    _getInvoiceEmail() {

        if (this.props.bookingValues.payment_method === 'invoice') {

            return (
                <span styleName="review-line">
                    { this.props.bookingValues.invoice_email }
                </span>
            );
        }
    }

    _getPurchaseOrderNumber() {

        if (this.props.bookingValues.payment_method === 'invoice' && this.props.bookingValues.po_number) {

            return (
                <div styleName="review-line">
                    <span>Purchase Order</span>&nbsp;
                    <span styleName="emph">{ this.props.bookingValues.po_number }</span>
                </div>
            );
        }
    }

    _getAddress() {

        const paymentMethod = this.props.bookingValues.payment_method;

        if (paymentMethod === 'card' || paymentMethod === 'invoice') {

            const billingAddress = this.props.bookingValues.billing_address;

            return (
                <div styleName="address">
                    <Label styleName="section-heading">
                        Billing Address
                    </Label>

                    <address>
                        <span styleName="address-line">{ billingAddress.address_1 }</span>
                        <span styleName="address-line">{ billingAddress.address_2 }</span>
                        <span styleName="address-line">{ billingAddress.town_city }</span>
                        <span styleName="address-line">{ billingAddress.post_code }</span>
                        <span styleName="address-line">{ this.props.country.name }</span>
                    </address>
                </div>
            );
        }
    }

    _getDelegatePrice() {
        if (this.props.event && this.props.event.overridden_price) {
            return this.props.event.overridden_price;
        } else if (this.props.eLearningCourse && this.props.eLearningCourse.overridden_price) {
            return this.props.eLearningCourse.overridden_price;
        }

        if (this.props.bookingValues.sector === 'public') {
            if (this.props.event) return this.props.event.public_price;
            if (this.props.eLearningCourse) return this.props.eLearningCourse.public_price;
        } else if (this.props.bookingValues.sector === 'private') {
            if (this.props.event) return this.props.event.private_price;
            if (this.props.eLearningCourse) return this.props.eLearningCourse.private_price;
        }
    }

    _getCostBreakdown() {

        const options = {
            is_elearning_course: !!this.props.eLearningCourse,
            course: this.props.event ? this.props.event.course : this.props.eLearningCourse,
            delegates: this.props.bookingValues.attendees,
            full_delegate_price: this._getDelegatePrice(),
            promotion_codes: this.props.promotionCodes,
            include_vat: this.props.country ? !!this.props.country.is_eu : true
        };

        return costCalculator.calculate(options);
    }

    _getDelegateDiscountReview() {

        const discountValue = parseFloat(this._getCostBreakdown().delegate_discount_value).toFixed(2);

        if (discountValue > 0) {

            return (
                <tr>
                    <td>Multiple Delegates Discount <span styleName="promotion-description--discount">(10% discount)</span></td>
                    <td>-£{ discountValue }</td>
                </tr>
            );
        }
    }

    _getPromotionDiscountsReview() {

        return this._getCostBreakdown().promotions.map((promo, index) => {

            return (
                <tr key={ index }>
                    <td>{ promo['label'] }&nbsp;
                        { promo['type'] === 'fixed_percentage' && (<span styleName="promotion-description--discount">({ promo['discount'] }% discount)</span>)}
                        { promo['type'] === 'fixed_value' && (<span styleName="promotion-description--discount">(&pound;{ parseFloat(promo['discount']).toFixed(2) } discount)</span>)}
                    </td>
                    <td>-&pound;{ parseFloat(promo['amount']).toFixed(2) }</td>
                </tr>
            );
        });
    }

    _termsAcceptanceUpdated(event) {

        this.setState({
            ...this.state,
            termsAccepted: event.target.checked
        });
    }

    _showTermsAndConditions() {

        this.setState({
            ...this.state,
            showingTerms: true
        });
    }

    _isAmountToPay() {

        const totalAmount = parseFloat(this._getCostBreakdown().total);

        return totalAmount > 0;
    }

    _getPaymentSummary() {

        if (!this._isAmountToPay()) {

            return (
                <p>No payment required</p>
            )
        }

        return (
            <div>
                { this._getPaymentMethod() }

                { this._getPurchaseOrderNumber() }

                { this._getInvoiceEmail() }

                { this._getAddress() }
            </div>
        )
    }

    render() {

        const { fields: {}, bookingValues, submitting, handleSubmit } = this.props;

        const vatPercent = this.props.includeVAT ? '20' : '0';

        const event = this.props.event ? eventFormatter.format(this.props.event) : null;
        const bookingTitle = this.props.event ? 'Event' : 'E-Learning';

        return (
            <form onSubmit={ handleSubmit(this.props.processBooking.bind(this, bookingValues)) }>

                <AccordionSection>

                    <div className={style['section-content-event-summary']}>

                        <Label styleName="section-heading">{bookingTitle}</Label>

                        <GlobalMessage className={ style['global-error'] }
                                       type="error"
                                       show={ this.props.globalEventError }>

                            { this.props.globalEventError }

                        </GlobalMessage>

                        {this.props.event &&  (<span styleName="event-line">{ event.course.module.name }</span>)}
                        {this.props.event && (<span styleName="event-line">{ event.course.name }</span>)}
                        {this.props.event && (<span styleName="event-line">{ event.date_range }</span>)}
                        {(this.props.event && this.props.event.course.type !== "webinar") && (<span styleName="event-line">{ event.venue_address_text }</span>)}

                        {this.props.eLearningCourse && (<span styleName="event-line">{ this.props.eLearningCourse.module.name }</span>)}
                        {this.props.eLearningCourse && (<span styleName="event-line">{ this.props.eLearningCourse.name }</span>)}

                    </div>
                </AccordionSection>

                <AccordionSection>

                    <Button type="button" onClick={ this.props.backToOrganisation } styleName="edit-link">Edit</Button>

                    <div className={style['section-content']}>

                        <Label styleName="section-heading">Organisation</Label>


                        <span styleName="review-line">{ bookingValues.organisation_name }</span>

                        <span styleName="review-line">{ this._getSector() } sector</span>

                        <span styleName="review-line">{ bookingValues.booking_email }</span>

                    </div>

                </AccordionSection>

                <AccordionSection>

                    <Button type="button" onClick={ this.props.backToDelegates } styleName="edit-link">Edit</Button>

                    <div className={style['section-content']}>

                        <Label styleName="section-heading">Delegates { this.props.eLearningCourse && this.props.eLearningCourse.sorted_elearning_units.length > 0 && 'and Modules' }</Label>

                        <GlobalMessage className={ style['global-error'] }
                                       type="error"
                                       show={ this.props.globalDelegatesError }>

                            { this.props.globalDelegatesError }

                        </GlobalMessage>

                        {
                            bookingValues.attendees.map((delegate, index) => {

                                return (
                                    <div key={ index } className={this.props.eLearningCourse && style['delegate-list-item--elearning']}>
                                        <span>{ delegate.first_name } { delegate.last_name }</span>

                                        {delegate.units && delegate.units.map(unit => {
                                            return <div><span>{ unit.title.replace(':', '') }</span></div>
                                        })}
                                    </div>
                                );
                            })
                        }
                    </div>

                </AccordionSection>

                <AccordionSection>

                    <Button type="button" onClick={ this.props.backToPayment } styleName="edit-link">Edit</Button>

                    <div className={style['section-content']}>

                        <Label styleName="section-heading">Payment</Label>

                        <GlobalMessage className={ style['global-error'] }
                                       type="error"
                                       show={ this.props.globalCardError }>

                            { this.props.globalCardError }

                        </GlobalMessage>

                        { this._getPaymentSummary() }
                    </div>

                </AccordionSection>

                <AccordionSection>

                    <div className={style['section-content-costs']}>

                        <Label styleName="section-heading">Costs</Label>

                        <table styleName="costs-table">
                            <tbody>

                            {this._getCostBreakdown().delegate_costs.map((delegate, i) => {

                                const unitCount = delegate.unit_ids ? delegate.unit_ids.length : 0;

                                return (
                                    <tr key={i}>
                                        <td>{ delegate.first_name } { delegate.last_name } { this.props.eLearningCourse && unitCount > 0 && `(Modules x ${unitCount})` }</td>
                                        <td>£{ parseFloat(delegate.price).toFixed(2) }</td>
                                    </tr>
                                );
                            })}

                            <tr>
                                <td>Subtotal</td>
                                <td>£{ parseFloat(this._getCostBreakdown().subtotal).toFixed(2) }</td>
                            </tr>

                            { this._getPromotionDiscountsReview() }

                            { this._getDelegateDiscountReview() }

                            <tr>
                                <td>Total (Ex VAT)</td>
                                <td>£{ parseFloat(this._getCostBreakdown().total_exc_vat).toFixed(2) }</td>
                            </tr>
                            <tr>
                                <td>VAT ({vatPercent}%)</td>
                                <td>£{ parseFloat(this._getCostBreakdown().total_vat).toFixed(2) }</td>
                            </tr>
                            <tr>
                                <td>Total</td>
                                <td>£{ parseFloat(this._getCostBreakdown().total).toFixed(2) }</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className={style['section-content-costs-mobile']}>
                        <span>The <strong>Summary of Costs</strong> is detailed below.</span>
                    </div>

                </AccordionSection>

                <AccordionSection styleName="terms-section">

                    <div className={style['section-content--terms']}>
                        <InputGroup>

                            <FancyCheckbox
                                className={style['terms-checkbox']}
                                checked={this.state.termsAccepted}
                                onChange={ this._termsAcceptanceUpdated.bind(this) }
                            />

                            <span>I accept the RHE Training</span>&nbsp;

                            <a styleName="show-terms-link"
                               onClick={ this._showTermsAndConditions.bind(this) }>
                                 Terms and Conditions
                            </a>

                        </InputGroup>

                        { this.state.showingTerms && (
                            <InputGroup>
                                { this.state.showingTerms ? <TermsAndConditions /> : null }
                            </InputGroup>
                        )}

                        <Button type="submit"
                                disabled={ submitting || this.props.globalCardError || !this.state.termsAccepted }
                                className={ style['confirm-button'] }>

                            <span>Confirm</span>

                        </Button>
                    </div>

                </AccordionSection>

            </form>
        );
    }
}

function mapStateToProps(state) {

    return state.payment;
}

function mapDispatchToProps(dispatch) {
    
    return {
        hideGlobalDelegatesError() {

            dispatch(paymentActions.hideGlobalDelegatesError());
        },
        hideGlobalCardError() {

            dispatch(paymentActions.hideGlobalCardError());
        },
        hideGlobalEventError() {

            dispatch(paymentActions.hideGlobalEventError());
        },
        backToOrganisation() {

            dispatch(paymentActions.backToOrganisation());
            scrollToElementId('organisation');
        },
        backToDelegates() {

            dispatch(paymentActions.backToDelegates());
            scrollToElementId('delegates');
        },
        backToPayment() {

            dispatch(paymentActions.backToPayment());
            scrollToElementId('payment');
        }
    };
}

const formParams = {
    form: 'booking-confirmation',
    fields: []
};

export default reduxForm(formParams, mapStateToProps, mapDispatchToProps)(CSSModules(BookingConfirmation, style));


// WEBPACK FOOTER //
// ./components/BookingConfirmation/index.js